export const ratioToPercentage = (ratio: number, invert = false): number => {
  const target = invert ? 1 - ratio : ratio;
  return target * 100;
};

export const percentageToRatio = (percentage: number, invert = false): number => {
  const target = invert ? 100 - percentage : percentage;
  return target / 100;
};
